import React, { useEffect } from 'react';
import clsx from 'clsx';
import { runIfFn } from '../utils/index.js';
import { useMediaZoomContext } from './MediaZoomContext.js';
export const MediaZoomItem = ({ item, children, skipRender = false, className, }) => {
    const { zoomEnabled, register, unregister, openItem } = useMediaZoomContext();
    useEffect(() => {
        register(item);
        return () => unregister(item.id);
    }, [item, register, unregister]);
    if (skipRender) {
        return null;
    }
    if (children) {
        return runIfFn(children, { open: () => openItem(item.id) });
    }
    const contentMarkup = (React.createElement("figure", { className: "w-full h-full flex ignore-typography justify-center bg-surface-subdued" },
        React.createElement("img", { className: "bg-surface-subdued object-cover object-center max-h-120", src: item.thumbnail, alt: item.alt })));
    if (!zoomEnabled) {
        return contentMarkup;
    }
    return (React.createElement("button", { type: "button", onClick: () => openItem(item.id), className: clsx('w-full', className) }, contentMarkup));
};
//# sourceMappingURL=MediaZoomItem.js.map